<template>
  <div class="modal fade confirm" :class="{'is-open': open}">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">
            編輯我的最愛
          </h3>
          <a class="btn btn-default m-0 float-right"
          @click="$emit('delete', favoriteData)">
            刪除此組合
          </a>
        </div>
        <div class="modal-body">
          <form class="form">
            <h3 class="m-0 d-inline-block">
              <span class="text mr-1">標題</span>
              <input type="text" class="form-control form-control-inline" v-model="form.favorite_name" maxlength="40" @input="checkFavName" />
            </h3>
            <!-- <h3 class="mt-3">個人資料 <span class="orange badget">8</span></h3> -->
            <h3 class="mt-3">個人資料</h3>
            <div class="panel panel-default collapse-panel mb-2">
              <a class="panel-header age">
                <h4 class="text-green m-0 ">
                  <i class="icon-collapse_down float-right"></i>
                  年紀相關
                </h4>
              </a>
              <div class="panel-body collapse">
                <div class="form-group row">
                  <label class="col-2 text-right">年齡</label>
                  <div class="col-10">
                    <div class="row">
                      <div v-for="(idage, index) in formItemData.formSelect.idage" :key="index" :class="[idage.ser_no === 3 ? colsi : coltr]">
                        <div v-if="!(idage.ser_no === 3)" class="radio">
                          <input type="radio" v-model="formSelectItem.idage" :id="`fa-age-${idage.ser_no}`" :value="idage.option">
                          <label :for="`fa-age-${idage.ser_no}`">{{ idage.name }}</label>
                        </div>
                        <div v-else class="radio">
                          <input type="radio" v-model="formSelectItem.idage" :id="`fa-age-${idage.ser_no}`" :value="`min:${form.extraAge[0]}/max:${form.extraAge[1]}`">
                          <label :for="`fa-age-${idage.ser_no}`">
                            <input type="text" class="form-control form-control-inline form-short" v-model="form.extraAge[0]" />
                            <span class="text">~</span>
                            <input type="text" class="form-control form-control-inline form-short" v-model="form.extraAge[1]" />
                            <span class="text">歲(含)</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="form-group row">
                      <label for="birthMonth" class="col-4 text-right">生日月份</label>
                      <div class="col-5">
                        <select v-model="formSelectItem.birthmonth" id="birthMonth" class="form-control">
                          <option value="">請選擇</option>
                          <option v-for="(birthmonth, index) in formItemData.formSelect.birthmonth" 
                          :key="index" 
                          :value="birthmonth.option">{{birthmonth.name}}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="form-group row">
                      <label for="add-age" class="col-4 text-right">增齡月份</label>
                      <div class="col-5">
                        <select v-model="formSelectItem.agemonth" id="add-age" class="form-control">
                          <option value="">請選擇</option>
                          <option v-for="(agemonth, index) in formItemData.formSelect.agemonth" 
                          :key="index" 
                          :value="agemonth.option">{{agemonth.name}}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="form-group row">
                      <label for="recent-birthday" class="col-4 text-right">近期生日</label>
                      <div class="col-3">
                        <select v-model="formSelectItem.recent_birthday" id="recent-birthday" class="form-control">
                          <option value="">請選擇</option>
                          <option v-for="(item, index) in formItemData.formSelect.recent_birthday" 
                          :key="index" 
                          :value="item.option">{{item.name}}</option>
                        </select>
                      </div>
                      <label class="text-right">日內生日</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="panel panel-default collapse-panel mb-2">
              <a class="panel-header info">
                <h4 class="text-green m-0">
                  <i class="icon-collapse_down float-right"></i>
                  基本資料
                </h4>
              </a>
              <div class="panel-body collapse">
                <div class="form-group row">
                  <label for="gender-1" class="col-2 text-right">性別</label>
                  <div class="col-10">
                    <div v-for="(sex, index) in formItemData.formSelect.sex" :key="index" class="radio radio-inline mr-5">
                      <input type="radio" name="gender" v-model="formSelectItem.sex" :id="`fa-gender-${sex.ser_no}`" :value="sex.option">
                      <label :for="`fa-gender-${sex.ser_no}`">{{sex.name}}</label>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="fa-group" class="col-2 text-right">現居地址</label>
                  <div class="col-10">
                    <select v-model="formSelectItem.home_addr.city" @change="changeCity" id="fa-group" class="form-control form-control-inline form-wide">
                      <option value="">請選擇縣市</option>
                      <option
                      v-for="(city, cid) in formItemData.cityOpt"
                      :key="`city-item-${cid}`"
                      :value="city">{{city}}</option>
                    </select>
                    <select v-model="formSelectItem.home_addr.zip" id="fa-group" class="form-control form-control-inline form-wide" :disabled="formSelectItem.home_addr.city===''">
                      <option value="">請選擇鄉鎮市區</option>
                      <option
                      v-for="(area, aid) in areaOpt"
                      :key="`area-item-${aid}`"
                      :value="area.area">{{area.area}}</option>
                    </select>
                    <input type="text" class="form-control form-control-inline form-wide" 
                    :disabled="formSelectItem.home_addr.zip === ''"
                    v-model="formSelectItem.home_addr.street" alt="ch">
                  </div>
                </div>
                <div class="form-group row">
                  <label for="fa-group" class="col-2 text-right">所屬群組</label>
                  <div class="col-10">
                    <div class="form-control h-auto"
                      @click="openGroupModal(formSelectItem.groups, formItemData.grpOpt)">
                      <div v-if='formSelectItem.groups.length == 0' style="padding:8px 0px;">
                      請選擇或輸入群組名稱
                      </div>
                      <div v-else>
                        <div class="d-inline-block p-2 ml-2 mb-2" style="border-radius: 4px;background-color: #e0e1e3;" 
                          v-for="(item,key) in formSelectItem.groups" :key="`selectedGroup-${key}`">
                          {{ item.text }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="fa-marriage" class="col-2 text-right">婚姻狀況</label>
                  <div class="col-10" id="fa-marriage">
                    <select v-model="formSelectItem.marry" class="form-control form-control-inline form-wide">
                      <option value="">請選擇</option>
                      <option v-for="(marry, index) in formItemData.formSelect.marry" :key="index" :value="marry.option">{{marry.name}}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="fa-education" class="col-2 text-right">教育程度</label>
                  <div class="col-10" id="fa-education">
                    <select v-model="formSelectItem.edu" class="form-control form-control-inline form-wide">
                      <option value="">請選擇</option>
                      <option v-for="(edu, index) in formItemData.formSelect.edu" :key="index" :value="edu.option">{{edu.name}}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="fa-career" class="col-2 text-right">職業</label>
                  <div class="col-10" id="fa-career">
                    <b v-if="formSelectItem.std_occupation_cd" class="text px-3 text-green">第{{ formSelectItem.jobCategory }}類  {{ formSelectItem.job_name }}</b>
                    <a class="btn btn-default m-0"  @click="jobPickingOpen=true">請選擇</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="panel panel-default collapse-panel mb-2">
              <a class="panel-header financial">
                <h4 class="text-green m-0">
                  <i class="icon-collapse_down float-right"></i>
                  財務狀況
                </h4>
              </a>
              <div class="panel-body collapse">
                <div class="form-group row">
                  <label class="col-2 text-right">個人年所得</label>
                  <div class="col-10">
                    <select v-model="formSelectItem.incomy" class="form-control form-control-inline form-wide">
                      <option value="">請選擇</option>
                      <option v-for="(incomy, index) in formItemData.formSelect.incomy" :key="index" :value="incomy.option">{{incomy.name}}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-2 text-right">家庭年所得</label>
                  <div class="col-10">
                    <select v-model="formSelectItem.family_incom" class="form-control form-control-inline form-wide">
                      <option value="">請選擇</option>
                      <option v-for="(family_incom, index) in formItemData.formSelect.family_incom" :key="index" :value="family_incom.option">{{family_incom.name}}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-2 text-right">月平均投資</label>
                  <div class="col-10">
                    <select v-model="formSelectItem.invest" class="form-control form-control-inline form-wide">
                      <option value="">請選擇</option>
                      <option v-for="(invest, index) in formItemData.formSelect.invest" :key="index" :value="invest.option">{{invest.name}}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-2 text-right">理財工具</label>
                  <div class="col-10">
                    <div v-for="(finance, index) in formItemData.formSelect.finance" :key="index" class="checkbox checkbox-inline">
                      <input v-if="finance.name == '無理財工具'" type="checkbox" :id="`fa-financial_tools-${finance.ser_no}`" 
                      v-model="formSelectItem.finance" 
                      :value="finance.option">
                      <input v-else type="checkbox" :id="`fa-financial_tools-${finance.ser_no}`" 
                      v-model="formSelectItem.finance" 
                      :disabled="formSelectItem.finance && formSelectItem.finance.includes('4')"
                      :value="finance.option">
                      <label :for="`fa-financial_tools-${finance.ser_no}`">{{finance.name}}</label>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-2 text-right">住屋狀況</label>
                  <div class="col-10">
                    <select v-model="formSelectItem.house" class="form-control form-control-inline form-wide">
                      <option value="">請選擇</option>
                      <option v-for="(house, index) in formItemData.formSelect.house" :key="index" :value="house.option">{{house.name}}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-2 text-right">交通工具</label>
                  <div class="col-10">
                    <div v-for="(car, index) in formItemData.formSelect.car" :key="index" class="radio radio-inline">
                      <input type="radio" :id="`fa-transport-${car.ser_no}`" v-model="formSelectItem.car" :value="car.option">
                      <label :for="`fa-transport-${car.ser_no}`">{{car.name}}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="panel panel-default collapse-panel mb-2">
              <a class="panel-header service">
                <h4 class="text-green m-0">
                  <i class="icon-collapse_down float-right"></i>
                  申辦資格
                </h4>
              </a>
              <div class="panel-body collapse">
                <div class="form-group row mt-2">
                  <label for="service_company-1" class="col-2 text-right">公司網站會員</label>
                  <div class="col-10">
                    <div v-for="(web_member, index) in formItemData.formSelect.web_member" :key="index" class="radio radio-inline">
                      <input type="radio" :id="`fa-service_company-${web_member.ser_no}`" v-model="formSelectItem.web_member" :value="web_member.option">
                      <label :for="`fa-service_company-${web_member.ser_no}`">{{web_member.name}}</label>
                    </div>
                  </div>
                </div>
                <div class="form-group row mt-2">
                  <label for="service_updateonline-1" class="col-2 text-right">網路服務線上變更</label>
                  <div class="col-10">
                    <div v-for="(online, index) in formItemData.formSelect.online" :key="index" class="radio radio-inline">
                      <input type="radio" :id="`fa-service_updateonline-${online.ser_no}`" v-model="formSelectItem.online" :value="online.option">
                      <label :for="`fa-service_updateonline-${online.ser_no}`">{{online.name}}</label>
                    </div>
                  </div>
                </div>
                <div class="form-group row mt-2">
                  <label for="service_mobile-1" class="col-2 text-right">行動服務</label>
                  <div class="col-10">
                    <div v-for="(mobile, index) in formItemData.formSelect.mobile" :key="index" class="radio radio-inline">
                      <input type="radio" :id="`fa-service_mobile-${mobile.ser_no}`" v-model="formSelectItem.mobile" :value="mobile.option">
                      <label :for="`fa-service_mobile-${mobile.ser_no}`">{{mobile.name}}</label>
                    </div>
                  </div>
                </div>
                <div class="form-group row mt-2">
                  <label for="service_onefinger-1" class="col-2 text-right">ID一指通</label>
                  <div class="col-10">
                    <div v-for="(payment, index) in formItemData.formSelect.payment" :key="index" class="radio radio-inline">
                      <input type="radio" :id="`fa-service_onefinger-${payment.ser_no}`" v-model="formSelectItem.payment" :value="payment.option">
                      <label :for="`fa-service_onefinger-${payment.ser_no}`">{{payment.name}}</label>
                    </div>
                  </div>
                </div>
                <div class="form-group row mt-2">
                  <label for="service_ebill-1" class="col-2 text-right">電子單據</label>
                  <div class="col-10">
                    <div v-for="(email, index) in formItemData.formSelect.email" :key="index" class="radio radio-inline">
                      <input type="radio" :id="`fa-service_ebill-${email.ser_no}`" v-model="formSelectItem.email" :value="email.option">
                      <label :for="`fa-service_ebill-${email.ser_no}`">{{email.name}}</label>
                    </div>
                  </div>
                </div>
                <div class="form-group row mt-2">
                  <label for="service_transfer-1" class="col-2 text-right">轉帳申請</label>
                  <div class="col-10">
                    <div v-for="(trans_plpy, index) in formItemData.formSelect.trans_plpy" :key="index" class="radio radio-inline">
                      <input type="radio" :id="`fa-service_transfer-${trans_plpy.ser_no}`" v-model="formSelectItem.trans_plpy" :value="trans_plpy.option">
                      <label :for="`fa-service_transfer-${trans_plpy.ser_no}`">{{trans_plpy.name}}</label>
                    </div>
                  </div>
                </div>
                <div class="form-group row mt-2">
                  <label for="service_eazycall-1" class="col-2 text-right">易Call保</label>
                  <div class="col-10">
                    <div v-for="(ecall, index) in formItemData.formSelect.ecall" :key="index" class="radio radio-inline">
                      <input type="radio" :id="`fa-service_eazycall-${ecall.ser_no}`" v-model="formSelectItem.ecall" :value="ecall.option">
                      <label :for="`fa-service_eazycall-${ecall.ser_no}`">{{ecall.name}}</label>
                    </div>
                  </div>
                </div>
                <div class="form-group row mt-2">
                  <label for="service_settlement-1" class="col-2 text-right">理賠抵繳</label>
                  <div class="col-10">
                    <div v-for="(claimoffset, index) in formItemData.formSelect.claimoffset" :key="index" class="radio radio-inline">
                      <input type="radio" :id="`fa-service_settlement-${claimoffset.ser_no}`" v-model="formSelectItem.claimoffset" :value="claimoffset.option">
                      <label :for="`fa-service_settlement-${claimoffset.ser_no}`">{{claimoffset.name}}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="panel panel-default collapse-panel mb-2">
              <a class="panel-header customerType">
                <h4 class="text-green m-0">
                  <i class="icon-collapse_down float-right"></i>
                  客戶類型
                </h4>
              </a>
              <div class="panel-body collapse">
                <div class="form-group row mt-2">
                  <label for="customerType-1" class="col-2 text-right">客戶關係</label>
                  <div class="col-10">
                    <div v-for="(custrl, index) in formItemData.formSelect.custrl" :key="index" class="radio radio-inline">
                      <input type="radio" :id="`fa-customerType-1-${custrl.ser_no}`" v-model="formSelectItem.custrl" :value="custrl.option">
                      <label :for="`fa-customerType-1-${custrl.ser_no}`">{{custrl.name}}</label>
                    </div>
                  </div>
                </div>
                <div class="form-group row mt-2">
                  <label for="customerType-2" class="col-2 text-right">保單關係人</label>
                  <div class="col-10">
                    <div v-for="(custrl1, index) in formItemData.formSelect.custrl1" :key="index" class="radio radio-inline">
                      <input type="radio" :id="`fa-customerType-2-${custrl1.ser_no}`" v-model="formSelectItem.custrl1" :value="custrl1.option">
                      <label :for="`fa-customerType-2-${custrl1.ser_no}`">{{custrl1.name}}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="form-group row">
                      <label for="add-age" class="col-4 text-right">幾年未再購</label>
                      <div class="col-5">
                        <select v-model="formSelectItem.custrl2" class="form-control">
                          <option value="">請選擇</option>
                          <option v-for="(year_select, index) in formSelectItem.year_select" 
                          :key="index" 
                          :value="year_select.option">{{year_select.name}}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="form-group row">
                      <label for="add-age" class="col-4 text-right">近期有購買</label>
                      <div class="col-5">
                        <select v-model="formSelectItem.custrl3" class="form-control">
                          <option value="">請選擇</option>
                          <option v-for="(year_select, index) in formSelectItem.year_select" 
                          :key="index" 
                          :value="year_select.option">{{year_select.name}}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="form-group row">
                      <label for="add-age" class="col-4 text-right">投保始期</label>
                      <div>
                        <span class="text">民國</span>
                        <input type="text" class="form-control form-control-inline form-short" v-model="formSelectItem.inputYear" maxlength="3" @input="checkYear" />
                        <span class="text">年</span>
                      </div>
                      <div class="col-3">
                        <select v-model="formSelectItem.custrl4" class="form-control">
                          <option value="">請選擇</option>
                          <option v-for="(month_select, index) in formSelectItem.month_select" 
                          :key="index" 
                          :value="month_select.option">{{month_select.name}}</option>
                        </select>
                      </div>
                     <span class="text">月</span>
                    </div>
                  </div>
                </div>
                <div class="form-group row mt-2">
                  <label for="customerType-6" class="col-2 text-right">VIP客戶</label>
                  <div class="col-10">
                    <div v-for="(vip_lvl, index) in formItemData.formSelect.vip_lvl" :key="index" class="checkbox checkbox-inline">
                      <input type="checkbox" :id="`fa-customerType-6-${vip_lvl.ser_no}`" v-model="formSelectItem.vip_lvl" :value="vip_lvl.option">
                      <label :for="`fa-customerType-6-${vip_lvl.ser_no}`">{{vip_lvl.name}}</label>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="fa-cust-tag" class="col-2 text-right">客戶標籤</label>
                  <div class="col-8">
                    <div class="form-control h-auto"
                      @click="openCustTagModal(formSelectItem.cust_tag)">
                      <div v-if='formSelectItem.cust_tag.length == 0' style="padding:8px 0px;">
                      請選擇客戶標籤
                      </div>
                      <div v-else>
                        <div class="d-inline-block p-2 ml-2 mb-2" style="border-radius: 4px;background-color: #e0e1e3;" 
                          v-for="(item,key) in formSelectItem.cust_tag" :key="`selectedCustTag-${key}`">
                          {{ item.text }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <label for="group" class="col-2 text-green underline" @click="openTagInfoModal">說明</label>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="form-group row">
                      <label class="col-4 text-right">符合名單專區次數</label>
                      <div class="col-5">
                        <select v-model="formSelectItem.match_cnt" class="form-control">
                          <option value="">請選擇</option>
                          <option v-for="(cnt_select, index) in formSelectItem.cnt_select" 
                          :key="index" 
                          :value="cnt_select.option">{{cnt_select.name}}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <h3>商品行銷</h3>
            <div class="panel panel-default collapse-panel mb-2">
              <a class="panel-header isInsure">
                <h4 class="text-green m-0">
                  <i class="icon-collapse_down float-right"></i>
                  已投保商品
                </h4>
              </a>
              <div class="panel-body collapse">
                <div class="form-group row mt-2">
                  <label class="col-2 text-right">主約幣別</label>
                  <div class="col-10">
                    <div class="checkbox checkbox-inline">
                      <input type="checkbox" id = 'prod_codes-f1'  value="NTD" v-model="formSelectItem.prod_codes_curr">
                      <label for="prod_codes-f1">台幣</label>
                    </div>
                    <div class="checkbox checkbox-inline">
                      <input type="checkbox" id = 'prod_codes-f2' value="USD" v-model="formSelectItem.prod_codes_curr">
                      <label for="prod_codes-f2">美元</label>
                    </div>
                    <div class="checkbox checkbox-inline">
                      <input type="checkbox" id = 'prod_codes-f3'  value="AUD" v-model="formSelectItem.prod_codes_curr">
                      <label for="prod_codes-f3">澳幣</label>
                    </div>
                    <div class="checkbox checkbox-inline">
                      <input type="checkbox" id = 'prod_codes-f4'  value="NZD" v-model="formSelectItem.prod_codes_curr">
                      <label for="prod_codes-f4">紐幣</label>
                    </div>
                    <div class="checkbox checkbox-inline">
                      <input type="checkbox" id = 'prod_codes-f5'  value="CNY" v-model="formSelectItem.prod_codes_curr">
                      <label for="prod_codes-f5">人民幣</label>
                    </div>  
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-2 text-right">主約險別</label>
                  <div class="col-10">
                    <div class="form-control h-auto" 
                    @click="openSelectModal(formSelectItem.prod_codes.main,formItemData.mainPlanOpt,'prod_codes','main')">
                      <div v-if='formSelectItem.prod_codes.main && formSelectItem.prod_codes.main.length == 0' style="padding:8px 0px;">
                        請選擇或輸入商品名稱
                      </div>
                      <div v-else>
                        <div class="d-inline-block p-2 ml-2 mb-2" style="border-radius: 4px;background-color: #e0e1e3;" 
                        v-for="(item,key) in formSelectItem.prod_codes.main" :key="`selectedMainContract2-${key}`">
                          {{ item.text }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label  class="col-2 text-right">附約險別</label>
                  <div class="col-10">
                    <div class="form-control h-auto" 
                    @click="openSelectModal(formSelectItem.prod_codes.atta,formItemData.secondaryPlanOpt,'prod_codes','atta')">
                      <div v-if='formSelectItem.prod_codes.atta && formSelectItem.prod_codes.atta.length == 0' style="padding:8px 0px;">
                        請選擇或輸入商品名稱
                      </div>
                      <div v-else>
                        <div class="d-inline-block p-2 ml-2 mb-2" style="border-radius: 4px;background-color: #e0e1e3;" 
                        v-for="(item,key) in formSelectItem.prod_codes.atta" :key="`selectedAttaContract2-${key}`">
                          {{ item.text }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-2 text-right">商品類別</label>
                  <div class="col-10">
                    <div class="form-control h-auto" 
                    @click="openProdTypeModal(formSelectItem.prod_type, '1')">
                      <div v-if='formSelectItem.prod_type && formSelectItem.prod_type.length == 0' style="padding:8px 0px;">
                        請選擇商品類別
                      </div>
                      <div v-else>
                        <div class="d-inline-block p-2 ml-2 mb-2" style="border-radius: 4px;background-color: #e0e1e3;" 
                        v-for="(item,key) in formSelectItem.prod_type" :key="`selected-prod-type-${key}`">
                          {{ item.text }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="panel panel-default collapse-panel mb-2">
              <a class="panel-header notInsure">
                <h4 class="text-green m-0">
                  <i class="icon-collapse_down float-right"></i>
                  未投保商品
                </h4>
              </a>
              <div class="panel-body collapse">
                <div class="form-group row mt-2">
                  <label class="col-2 text-right">主約險別</label>
                  <div class="col-10">
                    <div class="checkbox checkbox-inline">
                      <input type="checkbox" id = "prod_codes_n-f1" value="NTD" v-model="formSelectItem.prod_codes_n_curr">
                      <label for="prod_codes_n-f1">台幣</label>
                    </div>
                    <div class="checkbox checkbox-inline">
                      <input type="checkbox" id = "prod_codes_n-f2" value="USD" v-model="formSelectItem.prod_codes_n_curr">
                      <label for="prod_codes_n-f2">美元</label>
                    </div>
                    <div class="checkbox checkbox-inline">
                      <input type="checkbox" id = "prod_codes_n-f3" value="AUD" v-model="formSelectItem.prod_codes_n_curr">
                      <label for="prod_codes_n-f3">澳幣</label>
                    </div>
                    <div class="checkbox checkbox-inline">
                      <input type="checkbox" id = "prod_codes_n-f4" value="NZD" v-model="formSelectItem.prod_codes_n_curr">
                      <label for="prod_codes_n-f4">紐幣</label>
                    </div>
                    <div class="checkbox checkbox-inline">
                      <input type="checkbox" id = "prod_codes_n-f5" value="CNY" v-model="formSelectItem.prod_codes_n_curr">
                      <label for="prod_codes_n-f5">人民幣</label>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-2 text-right">主約險別</label>
                  <div class="col-10">
                    <div class="form-control h-auto" 
                    @click="openSelectModal(formSelectItem.prod_codes_n.main,formItemData.mainPlanOpt,'prod_codes_n','main')">
                      <div v-if='formSelectItem.prod_codes_n.main && formSelectItem.prod_codes_n.main.length == 0' style="padding:8px 0px;">
                        請選擇或輸入商品名稱
                      </div>
                      <div v-else>
                        <div class="d-inline-block p-2 ml-2 mb-2" style="border-radius: 4px;background-color: #e0e1e3;" 
                        v-for="(value,key) in formSelectItem.prod_codes_n.main" :key="`selectedMainContract2-${key}`">{{ value.text }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label  class="col-2 text-right">附約險別</label>
                  <div class="col-10">
                    <div class="form-control h-auto"
                    @click="openSelectModal(formSelectItem.prod_codes_n.atta,formItemData.secondaryPlanOpt,'prod_codes_n','atta')">
                      <div v-if='formSelectItem.prod_codes_n.atta && formSelectItem.prod_codes_n.atta.length == 0' style="padding:8px 0px;">
                        請選擇或輸入商品名稱
                      </div>
                      <div v-else>
                        <div class="d-inline-block p-2 ml-2 mb-2" style="border-radius: 4px;background-color: #e0e1e3;" 
                        v-for="(value,key) in formSelectItem.prod_codes_n.atta" :key="`selectedAttaContract2-${key}`">{{ value.text }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-2 text-right">商品類別</label>
                  <div class="col-10">
                    <div class="form-control h-auto" 
                    @click="openProdTypeModal(formSelectItem.prod_type_n, '2')">
                      <div v-if='formSelectItem.prod_type_n && formSelectItem.prod_type_n.length == 0' style="padding:8px 0px;">
                        請選擇商品類別
                      </div>
                      <div v-else>
                        <div class="d-inline-block p-2 ml-2 mb-2" style="border-radius: 4px;background-color: #e0e1e3;" 
                        v-for="(value,key) in formSelectItem.prod_type_n" :key="`selected-prod-type-n-${key}`">{{ value.text }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="panel panel-default collapse-panel mb-2">
              <a class="panel-header cathayCustInfo">
                <h4 class="text-green m-0">
                  <i class="icon-collapse_down float-right"></i>
                  泰好客
                </h4>
              </a>
              <div class="panel-body collapse">
                <div class="form-group row mt-2">
                  <label class="col-2 text-right">促約潛力</label>
                  <div class="col-10">
                    <div class="checkbox checkbox-inline">
                      <input type="checkbox" id = "fav_mkt_level_1" value="高" v-model="formSelectItem.mkt_level">
                      <label for="fav_mkt_level_1">高促約潛力</label>
                    </div>
                    <div class="checkbox checkbox-inline">
                      <input type="checkbox" id = "fav_mkt_level_2" value="中高" v-model="formSelectItem.mkt_level">
                      <label for="fav_mkt_level_2">中高促約潛力</label>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-2 text-right">商品類別</label>
                  <div class="col-10">
                    <div class="form-control h-auto" 
                    @click="openAddMktTypeModal(formSelectItem.mkt_type)">
                      <div v-if='formSelectItem.mkt_type && formSelectItem.mkt_type.length == 0' style="padding:8px 0px;">
                        請選擇商品類別
                      </div>
                      <div v-else>
                        <div class="d-inline-block p-2 ml-2 mb-2" style="border-radius: 4px;background-color: #e0e1e3;" 
                        v-for="(value,key) in formSelectItem.mkt_type" :key="`selected-mkt_type-${key}`">{{ value.text }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <h3>契約事件</h3>
            <div class="panel panel-default collapse-panel mb-2">
              <a class="panel-header futurePayment pb-3">
                <h4 class="text-green m-0">
                  <i class="icon-collapse_down float-right"></i>
                  給付
                </h4>
              </a>
              <div class="panel-body collapse">
                <div class="form-group row">
                  <label for="" class="col-2 text-right">滿期金即將給付</label>
                  <div class="col-10">
                    <select v-model="formSelectItem.matag_month" class="form-control">
                      <option value="">請選擇</option>
                      <option v-for="(matag_month, index) in formItemData.formSelect.matag_month" :key="index" :value="matag_month.option">{{matag_month.name}}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-2 text-right">年金即將給付</label>
                  <div class="col-10">
                    <select v-model="formSelectItem.annuity_month" class="form-control">
                      <option value="">請選擇</option>
                      <option v-for="(annuity_month, index) in formItemData.formSelect.annuity_month" :key="index" :value="annuity_month.option">{{annuity_month.name}}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="panel panel-default collapse-panel mb-2">
              <a class="panel-header payment">
                <h4 class="text-green m-0">
                  <i class="icon-collapse_down float-right"></i>
                  續保
                </h4>
              </a>
              <div class="panel-body collapse">
                <div class="form-group row">
                  <label for="" class="col-2 text-right">意外險</label>
                  <div class="col-10">
                    <select v-model="formSelectItem.pla1_month" class="form-control">
                      <option value="">請選擇</option>
                      <option v-for="(pla1_month, index) in formItemData.formSelect.pla1_month" :key="index" :value="pla1_month.option">{{pla1_month.name}}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="panel panel-default collapse-panel mb-2">
              <a class="panel-header propertyInsure">
                <h4 class="text-green m-0">
                  <i class="icon-collapse_down float-right"></i>
                  續保-產險<span class="text-red ml-4">※產險資訊僅能單獨查詢，不得與壽險資訊合併篩選</span>
                </h4>
              </a>
              <div class="panel-body collapse mt-3">
                <div class="form-group row">
                  <label for="" class="col-2 text-right">產險車險</label>
                  <div class="col-10">
                    <select v-model="formSelectItem.plc1_month" class="form-control">
                      <option value="">請選擇</option>
                      <option v-for="(plc1_month, index) in formItemData.formSelect.plc1_month" :key="index" :value="plc1_month.option">{{plc1_month.name}}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="" class="col-2 text-right">產險火險</label>
                  <div class="col-10">
                    <select v-model="formSelectItem.plf1_month" class="form-control">
                      <option value="">請選擇</option>
                      <option v-for="(plf1_month, index) in formItemData.formSelect.plf1_month" :key="index" :value="plf1_month.option">{{plf1_month.name}}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="action text-right">
              <a @click="$emit('close')" class="btn btn-default">取消</a>
              <a @click="handleClick" class="btn btn-primary" :disabled="submitDisable">儲存</a>
            </div>
          </form>
        </div>
      </div>
    </div>

    <warning-modal :open="warningModalRemindOpen" :showCancel="false" :message="'「續保-產險」僅能單獨篩選，不得與其他欄位項目合併篩選，請再次確認您勾選的項目。'" 
      :confirmText="'我知道了'" @submit="panelClose('warningModalRemindOpen')" />

    <!-- 職業選擇 modal -->
    <job-picking-modal :open="jobPickingOpen" @submit="submitJob" @close="jobPickingOpen=false" />

    <!-- 商品主附選擇 modal -->
    <add-contract-modal
     type="favoriteuse"
    :open="selectModalOpen"
    :selectedContract="modalSelected"
    :allContract="modalUnselected"
    :title="selectModalTitle"
    @close="panelClose('selectModalOpen')"
    @submit="updateContract"
    />

    <!-- 群組選擇 modal -->
    <add-multi-group-modal
     type="favoriteuse"
    :open="groupModalOpen"
    :selectedGroup="groupSelected"
    :allGroup="groupUnselected"
    @close="panelClose('groupModalOpen')"
    @submit="updateGroup"
    />

    <!-- 客戶標籤說明視窗 -->
    <tag-info-modal
      :open="tagInfoModalOpen"
      :data="formItemData.custTagOpt"
      @close="panelClose('tagInfoModalOpen')"
    />

    <!-- 客戶標籤選擇 modal -->
    <add-cust-tag-modal
       type="favoriteuse"
      :open="custTagModalOpen"
      :selectedTag="custTagSelected"
      :allTag="formItemData.custTagOpt"
      @close="panelClose('custTagModalOpen')"
      @submit="updateCustTag"
    />

    <!-- 商品類別選擇 modal -->
    <add-prod-type-modal
      type="favoriteuse"
      :open="prodTypeModalOpen"
      :selectedProd="prodTypeSelected"
      :prodType1="formItemData.prodType1_Opt"
      :prodType2="formItemData.prodType2_Opt"
      @close="panelClose('prodTypeModalOpen')"
      @submit="updateProdType"
    />

    <!-- 挑選商品類別(泰好客) -->
    <add-mkt-type-modal
      type="filteruse"
      :open="addMktTypeModalOpen"
      :selectedMktType="mktTypeSelected"
      @close="panelClose('addMktTypeModalOpen')"
      @submit="updateMktType"
    />
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import AddContractModal from '@/desktop/components/AddContractModal'
import AddMultiGroupModal from '@/desktop/components/AddMultiGroupModal'
import {commonMixin} from '@/mixins/common'
import { queryDistByCity } from '../../service'
import { setTimeout } from 'timers';
import AddCustTagModal from '@/desktop/components/AddCustTagModal'
import TagInfoModal from '@/desktop/components/TagInfoModal'
import AddProdTypeModal from '@/desktop/components/AddProdTypeModal'
import AddMktTypeModal from '@/desktop/components/AddMktTypeModal'
import JobPickingModal from '@/desktop/components/JobPickingModal';
import WarningModal from '../components/WarningModal'

export default {
  name: 'FavoriteModal',
  mixins: [commonMixin],
  components: {
    AddContractModal, AddMultiGroupModal, AddCustTagModal, TagInfoModal, AddProdTypeModal, AddMktTypeModal, JobPickingModal, WarningModal
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    favoriteData: {
      type: Object,
      default: null
    },
    formItemData: {
      type: Object,
      default: null
    }
  },
  watch: {
    formSelectItem : {
      deep: true,
      handler(newVal){  
        this.checkIsLifeInsOrPropertyIns(newVal,this.countSelection())
      },
    },
    'favoriteData': 'formDataChange',
    'form.extraAge': function(){
      if(this.form.extraAge[0] !== '' || this.form.extraAge[1] !== ''){
        this.formSelectItem.idage = `min:${this.form.extraAge[0]}/max:${this.form.extraAge[1]}`
      }
      
    },
    'formSelectItem.mkt_level' : function (val) {
      if (!val.length && this.formSelectItem.mkt_type.length) {
        this.formSelectItem.mkt_type = []; //取消勾選所有促約潛力，則把商品類別清空
      }
    },
    'formSelectItem.mkt_type' : function (val) {
      if (val && val.length) {
        if (this.formSelectItem.mkt_level && !this.formSelectItem.mkt_level.length) {
          this.formSelectItem.mkt_level.push("高");
          this.formSelectItem.mkt_level.push("中高");
        }
      } else {
        this.formSelectItem.mkt_level = []; //取消勾選商品類別，則把促約潛力清空
      }
    },
  },
  data () {
    return {
      coltr:'col-3',
      colsi:'col-6',
      jobPickingOpen: false,
      selectModalOpen: false,
      groupModalOpen: false,
      modalSelected: [],
      modalUnselected: [],
      groupSelected:[],
      groupUnselected: [],
      modalType: '',
      modalLevel: '',
      selectModalTitle: '',
      areaList: [],
      areaOpt: [],
      currentArea:'',
      customizeDataAll:{   //過濾資料用
        age: ['idage','birthmonth','agemonth','recent_birthday'],
        info: ['sex','home_addr1','home_addr2','home_addr3','groups','marry','edu','std_occupation_cd'],
        financial: ['incomy','family_incom','invest','finance','house','car'],
        service: ['web_member','online','mobile','payment','email','trans_plpy','ecall','claimoffset'],
        customerType:['custrl','custrl1','custrl2','custrl3','custrl4','vip_lvl','cust_tag','match_cnt'],
        isInsure: ['prod_codes', 'prod_type'],
        notInsure: ['prod_codes_n', 'prod_type_n'],
        futurePayment: ['matag_month','annuity_month'],
        payment: ['pla1_month'],
        propertyInsure: ['plc1_month','plf1_month'],
        cathayCustInfo: ['mkt_level', 'mkt_type']
      },
      formSelectItem: {
        idage:'',
        idageCustomize:'',
        agemonth:'',
        custrl:'',
        custrl1:'',
        custrl2:'',
        custrl3:'',
        custrl4:'',
        vip_lvl:[],
        std_occupation_cd:'',
        job_name: '',
        jobCategory: '',
        family_incom:'',
        finance:[], //Array
        invest:'',
        marry:'',
        edu:'',
        house:'',
        car:'',
        web_member:'',
        online:'',
        mobile:'',
        payment:'',
        email:'',
        sex:'',
        trans_plpy:'',
        ecall:'',
        claimoffset:'',
        matag_month:'',
        annuity_month:'',
        pla1_month:'',
        plc1_month:'',
        plf1_month:'',
        birthmonth:'',
        incomy:'',
        home_addr:{
          city:'',
          zip:'',
          street:'',
        },
        groups:[],
        prod_codes:{
          main:[],
          atta:[],
        },
        prod_codes_n:{
          main:[],
          atta:[],
        },
        prod_codes_curr:[],
        prod_codes_n_curr:[],
        year_select:[
          {"name":'半年內',"option":'半年內'},
          {"name":'一年內',"option":'一年內'},
          {"name":'二年內',"option":'二年內'},
          {"name":'三年內',"option":'三年內'},
          {"name":'四年內',"option":'四年內'},
          {"name":'五年內',"option":'五年內'}
        ],
        month_select:[
          {"name":'1',"option":'1'},
          {"name":'2',"option":'2'},
          {"name":'3',"option":'3'},
          {"name":'4',"option":'4'},
          {"name":'5',"option":'5'},
          {"name":'6',"option":'6'},
          {"name":'7',"option":'7'},
          {"name":'8',"option":'8'},
          {"name":'9',"option":'9'},
          {"name":'10',"option":'10'},
          {"name":'11',"option":'11'},
          {"name":'12',"option":'12'}
        ],
        cnt_select:[
          {"name":'2~4 次',"option":'1'},
          {"name":'5~7 次',"option":'2'},
          {"name":'8 次以上',"option":'3'}
        ],
        inputYear:'',
        cust_tag:[],
        match_cnt:'', //符合名單專區次數
        prod_type:[], //商品類別(已投保)
        prod_type_n:[], //商品類別(未投保)
        mkt_level:[], //泰好客行銷潛力
        mkt_type:[], //泰好客商品類別
      },
      form: {
        name: '我的組合',
        addFavrite: false,
        favriteName: '',
        extraAge: ['', ''],
        age: 0,
        gender: '',
        birthMonth: '',
        addAge: '',
        mainDoc: '',
        subDoc: '',
        liveArea: ['', ''],
        customerType: ['', ''],
        payment: [],
        propertyInsure:[]
      },
      custTagSelected: [], //已選擇的客戶標籤
      custTagModalOpen: false,
      tagInfoModalOpen: false,
      prodTypeSelected: [], //已選擇的商品類別
      prodTypeModalOpen: false,
      prodType:'', //當前選取的商品類別(1:已投保 / 2:未投保)
      mktTypeSelected: [], //已選擇的商品類別(泰好客)
      addMktTypeModalOpen: false,
      submitDisable: false,
      warningModalRemindOpen: false,
    }
  },
  methods: {
    handleClick(){
      this.$nextTick(() =>{
        if(!this.submitDisable){
          this.$emit('submit', this.formSelectItem,this.form.extraAge,this.areaOpt,this.form.favorite_name,this.favoriteData.favorite_name)
        }
      })
    },
    checkIsLifeInsOrPropertyIns(newObj,countSelection){
      const plf1_month = newObj['plf1_month'];
      const plc1_month = newObj['plc1_month'];
      if( countSelection === 0 && plc1_month==='' && plf1_month===''){
        this.submitDisable = true
      }else if( countSelection == 2   && plc1_month !== '' && plf1_month !== '' ){
        this.submitDisable = false
      }else if( countSelection > 1  && (plc1_month !== '' || plf1_month !== '') ){
        if( this.submitDisable === false ){
          this.showRemindModal();
        } 
        this.submitDisable = true
      }else{
        this.submitDisable = false
      }
    },
    countSelection() {  // 條件篩選已選取的總數量
      //理財工具(勾選「無理財工具時」，數量為1)
      let financeArrLength = this.formSelectItem.finance.length
      if (this.formSelectItem.finance.includes('4'))
        financeArrLength = 1

      let totalSelected = (
        this.numberCount(this.formSelectItem.idage) +
        this.numberCount(this.formSelectItem.birthmonth) +
        this.numberCount(this.formSelectItem.agemonth) +
        this.numberCount(this.formSelectItem.recent_birthday) +

        this.numberCount(this.formSelectItem.sex) +
        this.numberCount(this.formSelectItem.home_addr.city) +
        this.numberCount(this.formSelectItem.groups) +
        this.numberCount(this.formSelectItem.marry) +
        this.numberCount(this.formSelectItem.edu) +
        this.numberCount(this.formSelectItem.std_occupation_cd) +

        this.numberCount(this.formSelectItem.incomy) +
        this.numberCount(this.formSelectItem.family_incom) +
        this.numberCount(this.formSelectItem.invest) +
        financeArrLength +
        this.numberCount(this.formSelectItem.house) +
        this.numberCount(this.formSelectItem.car) +

        this.numberCount(this.formSelectItem.web_member) +
        this.numberCount(this.formSelectItem.online) +
        this.numberCount(this.formSelectItem.mobile) +
        this.numberCount(this.formSelectItem.payment) +
        this.numberCount(this.formSelectItem.email) +
        this.numberCount(this.formSelectItem.trans_plpy) +
        this.numberCount(this.formSelectItem.ecall) +
        this.numberCount(this.formSelectItem.claimoffset) +

        this.numberCount(this.formSelectItem.custrl) +
        this.numberCount(this.formSelectItem.custrl1) +
        this.numberCount(this.formSelectItem.custrl2) +
        this.numberCount(this.formSelectItem.custrl3) +
        this.numberCount(this.formSelectItem.inputYear) +
        this.numberCount(this.formSelectItem.vip_lvl) +
        this.numberCount(this.formSelectItem.cust_tag) +
        this.numberCount(this.formSelectItem.match_cnt) +

        this.formSelectItem.prod_codes_curr.length +
        this.numberCount(this.formSelectItem.prod_codes.main) +
        this.numberCount(this.formSelectItem.prod_codes.atta) +
        this.numberCount(this.formSelectItem.prod_type) +

        this.formSelectItem.prod_codes_n_curr.length +
        this.numberCount(this.formSelectItem.prod_codes_n.main) +
        this.numberCount(this.formSelectItem.prod_codes_n.atta) +
        this.numberCount(this.formSelectItem.prod_type_n) +

        this.formSelectItem.mkt_level.length +
        this.numberCount(this.formSelectItem.mkt_type) +

        this.numberCount(this.formSelectItem.matag_month) +
        this.numberCount(this.formSelectItem.annuity_month) +

        this.numberCount(this.formSelectItem.pla1_month) +
        this.numberCount(this.formSelectItem.plc1_month) +
        this.numberCount(this.formSelectItem.plf1_month)
      )

      return totalSelected
    },
    //選擇職業
    submitJob(job) {
      this.formSelectItem.job_name = job.job_name;
      this.formSelectItem.jobCategory = job.job_cat;
      this.formSelectItem.std_occupation_cd = job.job_code;
      this.jobPickingOpen = false;
    },
    //檢查我的最愛標題
    checkFavName(){
      this.form.favorite_name = this.cleanSpecialChar(this.form.favorite_name, '@()_&');
      if (this.stringBytes(this.form.favorite_name, false, 40) > 40) {
        this.form.favorite_name = this.form.favorite_name.substring(0, this.stringBytes(this.form.favorite_name, true, 40));
      }
    },
    //檢查投保始期-年份
    checkYear(){
      this.formSelectItem.inputYear = this.formSelectItem.inputYear.replace(/[^\d]/g,'');
    },
    //選取時回傳的數量
    numberCount(item) {
      let type = typeof (item)
      if (type !== undefined) {
        if (item.length === 0)
          return 0
        else
          return 1
      }
      return 0
    },
    ...mapActions([
      'setPageLock'
    ]),
    formDataChange(val) {
      this.form = {
        name: '我的組合',
        addFavrite: false,
        favriteName: '',
        extraAge: ['', ''],
        age: 0,
        gender: '',
        birthMonth: '',
        addAge: '',
        mainDoc: '',
        subDoc: '',
        liveArea: ['', ''],
        customerType: ['', ''],
        payment: [],
        ...val
      }
      this.formSelectItem = {
        idage:'',
        idageCustomize:'',
        agemonth:'',
        custrl:'',
        custrl1:'',
        custrl2:'',
        custrl3:'',
        custrl4:'',
        vip_lvl:[],
        std_occupation_cd:'',
        family_incom:'',
        finance:[], //Array
        invest:'',
        marry:'',
        edu:'',
        house:'',
        car:'',
        web_member:'',
        online:'',
        mobile:'',
        payment:'',
        email:'',
        sex:'',
        trans_plpy:'',
        ecall:'',
        claimoffset:'',
        matag_month:'',
        annuity_month:'',
        pla1_month:'',
        plc1_month:'',
        plf1_month:'',
        birthmonth:'',
        incomy:'',
        home_addr:{
          city:'',
          zip:'',
          street:'',
        },
        groups:[],
        prod_codes:{
          main:[],
          atta:[],
        },
        prod_codes_n:{
          main:[],
          atta:[],
        },
        prod_codes_curr:[],
        prod_codes_n_curr:[],
        year_select:[
          {"name":'半年內',"option":'半年內'},
          {"name":'一年內',"option":'一年內'},
          {"name":'二年內',"option":'二年內'},
          {"name":'三年內',"option":'三年內'},
          {"name":'四年內',"option":'四年內'},
          {"name":'五年內',"option":'五年內'}
        ],
        month_select:[
          {"name":'1',"option":'1'},
          {"name":'2',"option":'2'},
          {"name":'3',"option":'3'},
          {"name":'4',"option":'4'},
          {"name":'5',"option":'5'},
          {"name":'6',"option":'6'},
          {"name":'7',"option":'7'},
          {"name":'8',"option":'8'},
          {"name":'9',"option":'9'},
          {"name":'10',"option":'10'},
          {"name":'11',"option":'11'},
          {"name":'12',"option":'12'}
        ],
        cnt_select:[
          {"name":'2~4 次',"option":'1'},
          {"name":'5~7 次',"option":'2'},
          {"name":'8 次以上',"option":'3'}
        ],
        inputYear:'',
        cust_tag:[],
        match_cnt:'', //符合名單專區次數
        prod_type:[], //商品類別(已投保)
        prod_type_n:[], //商品類別(未投保)
        recent_birthday:'', //近期生日
        mkt_level:[],
        mkt_type:[]
      }

      let fa_field_name = this.favoriteData.field_name.split('-')
      let fa_option = this.favoriteData.option.split('-')
      let fa_option_ch = this.favoriteData.option_ch.split(';')
      fa_field_name.forEach((key,index) => {
        if(key === 'finance'){  //過濾投資工具
          if(fa_option[index].replace(/0/g,'') === ''){
            this.formSelectItem.finance = ['4']
          }else{
            this.formSelectItem.finance = fa_option[index].replace(/0/g,'').split('').map(item => {return Number(item)})
          }
        }else if (key === 'home_addr1'){   //過濾縣市
          this.formSelectItem.home_addr.city = fa_option[index]
        }else if (key === 'home_addr2'){  //過濾地區
          this.changeCity(fa_option[index])
          setTimeout(() => {
            this.formSelectItem.home_addr.zip = fa_option[index]
          }, 200);
        }else if (key === 'home_addr3'){   //過濾地址
          this.formSelectItem.home_addr.street = fa_option[index]
        }else if (key === 'prod_codes'){   //過濾已投保
          let MA = `${fa_option_ch[index].indexOf('主約') > -1 ? 'M' : ''}${fa_option_ch[index].indexOf('附約') > -1 ? 'A' : ''}`
          if (MA == 'M') {
            //已投保商品只有主約
            this.formSelectItem.prod_codes.main = fa_option_ch[index].replace('已投商品:主約:','').split(':').map(item => {
              let mainAry = this.$store.state.prodMainCode.filter(main=> { return main.val == item})
              let chkMainAry = mainAry && mainAry.length > 0 ? true : false
              return {
                text: chkMainAry ? mainAry[0].text : item,
                val: chkMainAry ? item : item.trim().match(/[^()]+(?=\))/g)[0]
              }
            })
          } else if (MA == 'A') {
            //已投保商品只有附約
            this.formSelectItem.prod_codes.atta = fa_option_ch[index].replace('已投商品:附約:','').split(':').map(item => {
              let subAry = this.$store.state.prodSubCode.filter(main=> { return main.val == item})
              let chkSubAry = subAry && subAry.length > 0 ? true : false
              return {
                text: chkSubAry ? subAry[0].text : item,
                val: chkSubAry ? item : item.trim().match(/[^()]+(?=\))/g)[0]
              }
            })
          } else if (MA == 'MA') {
            //已投保商品有主約&附約
            let dataAry = fa_option_ch[index].split('附約:')
            this.formSelectItem.prod_codes.main = dataAry[0].replace('已投商品:主約:','').split(':').map(item => {
              let mainAry = this.$store.state.prodMainCode.filter(main=> { return main.val == item})
              let chkMainAry = mainAry && mainAry.length > 0 ? true : false
              return {
                text: chkMainAry ? mainAry[0].text : item,
                val: chkMainAry ? item : item.trim().match(/[^()]+(?=\))/g)[0]
              }
            })
            this.formSelectItem.prod_codes.atta = dataAry[1].split(':').map(item => {
              let subAry = this.$store.state.prodSubCode.filter(main=> { return main.val == item})
              let chkSubAry = subAry && subAry.length > 0 ? true : false
              return {
                text: chkSubAry ? subAry[0].text : item,
                val: chkSubAry ? item : item.trim().match(/[^()]+(?=\))/g)[0]
              }
            })
          }
        } else if (key === 'prod_codes_n') {   //過濾未投保
          let MA = `${fa_option_ch[index].indexOf('主約') > -1 ? 'M' : ''}${fa_option_ch[index].indexOf('附約') > -1 ? 'A' : ''}`
          if(MA == 'M'){
            //未投保商品只有主約
            this.formSelectItem.prod_codes_n.main = fa_option_ch[index].replace('未投商品:主約:','').split(':').map(item => {
              let mainAry = this.$store.state.prodMainCode.filter(main=> { return main.val == item})
              let chkMainAry = mainAry && mainAry.length > 0 ? true : false
              return {
                text: chkMainAry ? mainAry[0].text : item,
                val: chkMainAry ? item : item.trim().match(/[^()]+(?=\))/g)[0]
              }
            })
          } else if(MA == 'A') {
            //未投保商品只有附約
            this.formSelectItem.prod_codes_n.atta = fa_option_ch[index].replace('未投商品:附約:','').split(':').map(item => {
              let subAry = this.$store.state.prodSubCode.filter(main=> { return main.val == item})
              let chkSubAry = subAry && subAry.length > 0 ? true : false
              return {
                text: chkSubAry ? subAry[0].text : item,
                val: chkSubAry ? item : item.trim().match(/[^()]+(?=\))/g)[0]
              }
            })
          } else if(MA == 'MA') {
            //未投保商品有主約&附約
            let dataAry = fa_option_ch[index].split('附約:')
            this.formSelectItem.prod_codes_n.main = dataAry[0].replace('未投商品:主約:','').split(':').map(item => {
              let mainAry = this.$store.state.prodMainCode.filter(main=> { return main.val == item})
              let chkMainAry = mainAry && mainAry.length > 0 ? true : false
              return {
                text: chkMainAry ? mainAry[0].text : item,
                val: chkMainAry ? item : item.trim().match(/[^()]+(?=\))/g)[0]
              }
            })
            this.formSelectItem.prod_codes_n.atta = dataAry[1].split(':').map(item => {
              let subAry = this.$store.state.prodSubCode.filter(main=> { return main.val == item})
              let chkSubAry = subAry && subAry.length > 0 ? true : false
              return {
                text: chkSubAry ? subAry[0].text : item,
                val: chkSubAry ? item : item.trim().match(/[^()]+(?=\))/g)[0]
              }
            })
          }
        }else if(key === 'prod_codes_curr'){ //有投保幣別
          this.formSelectItem.prod_codes_curr = fa_option[index].split(':').map(item => {return item})
        }else if(key === 'prod_codes_n_curr'){
          this.formSelectItem.prod_codes_n_curr = fa_option[index].split(':').map(item => {return item})
        }else if (key === 'idage'){   //年紀
          let setByUser = ''
          this.formItemData.formSelect.idage.forEach(item => {
            if(item.option === fa_option[index]){
              setByUser = setByUser + '1'
            }
          })
          if(setByUser === ''){
            let getNewNum = fa_option[index].replace(/.{3}\:/g,'').split('/')
            
            
            this.form.extraAge[0] = getNewNum[0]
            this.form.extraAge[1] = getNewNum[1]
            this.formSelectItem.idage = fa_option[index]
          }else{
            this.formSelectItem.idage = fa_option[index]
          }
        } else if (key === 'idageCustomize') {
          let ageVal = fa_option[index];
          let newAgeVal = ageVal.match(/\d+/) || ''; //取得數字部分
          if (ageVal.indexOf('min') > -1) {
            this.form.extraAge[0] = newAgeVal[0];
          } else {
            this.form.extraAge[1] = newAgeVal[0];
          }
          this.formSelectItem.idage = ageVal;
        } else if (key === 'inputYearOnly') {
          this.formSelectItem.inputYear = fa_option[index];
        } else if (key === 'custrl4Only') {
          this.formSelectItem.custrl4 = fa_option[index];
        } else if (key === 'groups'){   //過濾群組
          let grpNameArr = fa_option_ch[index].replace('所屬群組:','').split(':');
          let grpValArr = fa_option[index].split(':');
          for(var i = 0; i < grpNameArr.length; i++){
            let grpArr = {
              text:grpNameArr[i],
              val:grpValArr[i]
            }
            this.formSelectItem.groups.push(grpArr);
          }
        } else if (key === 'vip_lvl'){ //VIP客戶
          this.formSelectItem.vip_lvl = fa_option[index].split(':').map(item => {return item;});
        } else if (key === 'cust_tag'){ //客戶標籤
          let tagNameArr = fa_option_ch[index].replace('客戶標籤:','').split(':');
          let tagValArr = fa_option[index].split(':');
          for(var t = 0; t < tagNameArr.length; t++){
            let tagArr = {
              text:tagNameArr[t],
              val:tagValArr[t]
            }
            this.formSelectItem.cust_tag.push(tagArr);
          }
        } else if (key === 'prod_type') { //商品類別(已投保)
           let prodTypeNameArr = fa_option_ch[index].replace('商品類別(已投保):','').split(':');
           let prodTypeValArr = fa_option[index].split(':');
            for(var p1 = 0; p1 < prodTypeNameArr.length; p1++){
              let prodTypeArr = {
                text:prodTypeNameArr[p1],
                val:prodTypeValArr[p1]
              }
            this.formSelectItem.prod_type.push(prodTypeArr);
          }
        } else if (key === 'prod_type_n') { //商品類別(未投保)
          let prodType_N_NameArr = fa_option_ch[index].replace('商品類別(未投保):','').split(':');
          let prodType_N_ValArr = fa_option[index].split(':');
          for(var p2 = 0; p2 < prodType_N_NameArr.length; p2++){
            let prpdType_N_Arr = {
              text:prodType_N_NameArr[p2],
              val:prodType_N_ValArr[p2]
            }
            this.formSelectItem.prod_type_n.push(prpdType_N_Arr);
          }
        } else if (key === 'mkt_level') { //泰好客促約潛力
          this.formSelectItem.mkt_level = fa_option[index].split(':').map(item => {return item})
        } else if (key === 'mkt_type') { //泰好客商品類別
          let mktType_NameArr = fa_option_ch[index].replace('泰好客商品類別:','').split(':');
          let mktType_ValArr = fa_option[index].split(':');
          for(let y = 0; y < mktType_NameArr.length; y++){
            let mktType_Arr = {
              text:mktType_NameArr[y],
              val:mktType_ValArr[y]
            }
            this.formSelectItem.mkt_type.push(mktType_Arr);
          }
        } else if (key === 'std_occupation_cd') { //職業
          const pattern = /\W(\d+)\W\s(\W+)/;
          const match = fa_option_ch[index].match(pattern);
          this.formSelectItem[key] = fa_option[index]
          this.formSelectItem['jobCategory'] = match[1]
          this.formSelectItem['job_name'] = match[2]        
        } else {
          this.formSelectItem[key] = fa_option[index]
        }
      });
      this.checkSelect()
      this.registerHanlink() // for 難字
    },
    changeCity (key = '') {
      this.formSelectItem.home_addr.zip = ''
      this.formSelectItem.home_addr.street = ''
      if(this.formSelectItem.home_addr.city == ''){
        this.areaOpt = []
      }else{
        queryDistByCity(this.$store.state.userInfo.id, this.formSelectItem.home_addr.city).then(result => {
          if(result.body.cityAreaList) {  
            this.areaOpt = result.body.cityAreaList.map(item => { return {area: item.AREA, city:item.CITY, zipcode:item.ZIPCODE}})
          } else {
            this.areaOpt = []
          }
          this.formSelectItem.home_addr.zip = key
        })
      }
    },
    updateContract (selectedList) {  //  更新已選擇投保商品
      this.formSelectItem[this.modalType][this.modalLevel] = selectedList
      this.panelClose('selectModalOpen')
    },
    showRemindModal(){
      this.panelOpen('warningModalRemindOpen')
    },
    openSelectModal(selected,unselected, type, level) {   //  打開投保商品選擇 modal
      this.modalSelected = selected;
      this.modalUnselected = unselected;
      this.modalType = type
      this.modalLevel = level
      if (type == 'prod_codes') {
        if(level == 'main') {
          this.selectModalTitle = '已投保主約'
        }else if(level == 'atta') {
          this.selectModalTitle = '已投保附約'
        }
      }else if (type == 'prod_codes_n') {
        if(level == 'main') {
          this.selectModalTitle = '未投保主約'
        } else if (level == 'atta'){
          this.selectModalTitle = '未投保附約'
        }
      }
      this.panelOpen('selectModalOpen')
    },
    updateGroup (selectedList) {  //  更新已選擇群組
      this.formSelectItem['groups'] = selectedList
      this.panelClose('groupModalOpen')
    },
    openGroupModal(selected, unselected) {  //  打開群組選擇 modal
      this.groupSelected = selected;
      this.groupUnselected = unselected;
      this.panelOpen('groupModalOpen');
    },    
    checkSelect(){
      let hasSelect = []
      const DataAll = this.customizeDataAll
      const SelectString = this.favoriteData.field_name
      const toggleItem = ['age','info','financial','service','customerType','isInsure','notInsure','futurePayment','payment','propertyInsure']
      
      for(let i in DataAll){
        let hasVal = false
        DataAll[i].forEach(val => {
          if(SelectString.indexOf(val) > -1){
            hasVal = true
          }
        })
        if(hasVal){
          hasSelect.push(i)
        }
      }
      
      document.querySelectorAll('.panel-header').forEach(element => {
        
        if (element.nextSibling.classList.contains('in')) {
          element.classList.remove('is-in')
          element.nextSibling.classList.remove('in')
        } 
      });
      hasSelect.forEach(item => {
        document.querySelector(`.${item}`).classList.add('is-in')
        document.querySelector(`.${item}`).nextSibling.classList.add('in')
      })
      
    },
    stringBytes(c, isSub, size){ //計算字元長度 (字串, 是否檢查, 檢查的長度) 
      var n=c.length,s;
      var len=0;
      for(var i=0; i <n;i++){
        s=c.charCodeAt(i);
        while( s > 0 ){
          len++;
          s = s >> 8;
          if(isSub&&len>size){
            return i;
          }
        }
      }
      return len;
    },
    //開啟標籤名稱說明視窗
    openTagInfoModal () {
      this.panelOpen('tagInfoModalOpen');
    },
    //更新已選擇客戶標籤
    updateCustTag (selectedList) {
      this.formSelectItem['cust_tag'] = selectedList;
      this.panelClose('custTagModalOpen');
    },
    //打開客戶標籤選擇 modal
    openCustTagModal(selected) { 
      this.custTagSelected = selected;
      this.panelOpen('custTagModalOpen');
    },
    //更新已選擇商品類別
    updateProdType (selectedList) {
      if (this.prodType == '1') {
        this.formSelectItem['prod_type'] = selectedList;
      } else {
        this.formSelectItem['prod_type_n'] = selectedList;
      }
      this.panelClose('prodTypeModalOpen');
    },
    //打開商品類別選擇 modal
    openProdTypeModal(selected, type) {
      this.prodTypeSelected = selected;
      this.prodType = type;
      this.panelOpen('prodTypeModalOpen');
    },
    //更新已選擇商品類別(泰好客)
    updateMktType (selectedList) {
      this.formSelectItem['mkt_type'] = selectedList;
      this.panelClose('addMktTypeModalOpen');
    },
    //打開挑選商品類別(泰好客) modal
    openAddMktTypeModal(selected) {
      this.mktTypeSelected = selected;
      this.panelOpen('addMktTypeModalOpen');
    }
  },
  mounted () {
    document.querySelectorAll('.panel-header').forEach(element => {
      element.addEventListener('click', function () {
        if (this.nextSibling.classList.contains('in')) {
          this.classList.remove('is-in')
          this.nextSibling.classList.remove('in')
        } else {
          this.classList.add('is-in')
          this.nextSibling.classList.add('in')
        }
      })
    });
  }
} 
</script>
